<template>
  <div class="page-title" :style="{backgroundColor: bgColor}">
      <h1 class="f-55 regular to-lowercase" :style="{color: titleColor}">{{ pageTitle }}</h1>
  </div>
</template>

<script>
export default {
props: ['pageTitle', 'titleColor', 'bgColor'],
}
</script>

<style>

</style>